// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * El globo del botón *What's new* del dashboard (20-oct-2026). La pastilla la pone el dashboard (\`.resetBtn\`, la misma
 * de *Refresh*); aquí solo va lo que lo distingue cuando hay algo sin ver.
 */

/*
 * Naranja sólido con letra oscura, como la etiqueta "New" de *What's new*: el naranja es lo nuevo en toda la pantalla
 * de novedades, y sobre la pastilla oscura se lee en los dos temas.
 *
 * 📌 Mide 18 px y la línea del texto unos 16: el margen negativo de arriba y abajo evita que el globo haga esta
 * pastilla más alta que la de *Refresh*, que está al lado.
 */
.WhatsNewButton_badge__dwXTB {
  min-width: 18px;
  height: 18px;
  margin: -1px 0 -1px 2px;
  padding: 0 5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: var(--dylo-orange);
  color: #1b1306;
  font-size: 10.5px;
  font-weight: 700;
  line-height: 1;
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--dylo-orange) 24%, transparent);
  animation: WhatsNewButton_wnb-pulse__pYa0t 2.2s ease-in-out infinite;
}

/* Un latido suave del aro: se nota sin distraer del tablero. */
@keyframes WhatsNewButton_wnb-pulse__pYa0t {
  0%,
  100% {
    box-shadow: 0 0 0 3px color-mix(in srgb, var(--dylo-orange) 24%, transparent);
  }
  50% {
    box-shadow: 0 0 0 5px color-mix(in srgb, var(--dylo-orange) 8%, transparent);
  }
}

@media (prefers-reduced-motion: reduce) {
  .WhatsNewButton_badge__dwXTB {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/v2/pages/Dashboard/components/WhatsNewButton.module.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;;;;;;EAME;AACF;EACE,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,8BAA8B;EAC9B,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,6EAA6E;EAC7E,oEAA8C;AAChD;;AAEA,+DAA+D;AAC/D;EACE;;IAEE,6EAA6E;EAC/E;EACA;IACE,4EAA4E;EAC9E;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["/*\n * El globo del botón *What's new* del dashboard (20-oct-2026). La pastilla la pone el dashboard (`.resetBtn`, la misma\n * de *Refresh*); aquí solo va lo que lo distingue cuando hay algo sin ver.\n */\n\n/*\n * Naranja sólido con letra oscura, como la etiqueta \"New\" de *What's new*: el naranja es lo nuevo en toda la pantalla\n * de novedades, y sobre la pastilla oscura se lee en los dos temas.\n *\n * 📌 Mide 18 px y la línea del texto unos 16: el margen negativo de arriba y abajo evita que el globo haga esta\n * pastilla más alta que la de *Refresh*, que está al lado.\n */\n.badge {\n  min-width: 18px;\n  height: 18px;\n  margin: -1px 0 -1px 2px;\n  padding: 0 5px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 999px;\n  background: var(--dylo-orange);\n  color: #1b1306;\n  font-size: 10.5px;\n  font-weight: 700;\n  line-height: 1;\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--dylo-orange) 24%, transparent);\n  animation: wnb-pulse 2.2s ease-in-out infinite;\n}\n\n/* Un latido suave del aro: se nota sin distraer del tablero. */\n@keyframes wnb-pulse {\n  0%,\n  100% {\n    box-shadow: 0 0 0 3px color-mix(in srgb, var(--dylo-orange) 24%, transparent);\n  }\n  50% {\n    box-shadow: 0 0 0 5px color-mix(in srgb, var(--dylo-orange) 8%, transparent);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .badge {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badge": `WhatsNewButton_badge__dwXTB`,
	"wnb-pulse": `WhatsNewButton_wnb-pulse__pYa0t`
};
export default ___CSS_LOADER_EXPORT___;
